<template>
  <section class="search_aside_widget_section mb_dn">
    <div v-if="$store.state.burgerExpanded">
      <b-input-group>
        <b-form-input size="sm" autocomplete="off" id="search_applicant_widget_input" :placeholder="'Поиск по кандидатам'" @input="search = $event" :value="search"></b-form-input>
        <b-input-group-prepend> <b-icon icon="search"></b-icon></b-input-group-prepend>
        <b-input-group-append v-show="search"><button class="no_btn close_btn" @click="search = ''"><close-search-svg/></button></b-input-group-append>
      </b-input-group>
      <div class="search_result_container" v-show="search.length">
        <p>Результаты поиска: Найдено {{pagination.total}}</p>
        <ul class="chrome_scrollbar" v-infinite-scroll="loadMore" :infinite-scroll-disabled="disableScroll" infinite-scroll-distance="5">
          <li :key="applicant.id" v-for="(applicant, index) in applicants" :data-id="applicant.id">
            <div class="photo_block">
              <img v-if="applicant.photo" :src="'https://storage.hr-crm.io/applicants_photos/'+applicant.photo" class="img-thumbnail rounded-circle"/>
              <img v-else :src="'/thumbnails.php?h=48&w=48&src=/no-photo.png'" class="img-thumbnail rounded-circle"/>
            </div>
            <div class="title_block">
              <router-link v-b-tooltip:hover :title="applicant.full_title" id="search_result_link" :to="`/applicant/${applicant.id}`">{{applicant.title}}</router-link>
              <small>{{applicant.email}}</small>
            </div>
            <section class="info_section" v-if="applicant.vacancy">
              <p>{{applicant.vacancy.title}}</p>
              <small>{{applicant.vacancy.project.title}}</small>
            </section>
          </li>
          <transition name="fade">
            <div class="spinner_block"><b-spinner v-show="scroll_loader && applicants.length" variant="primary" style="width: 3rem; height: 3rem;" label="Spinning"></b-spinner></div>
          </transition>
        </ul>
      </div>
    </div>
    <div v-else><button class="no_btn" @click="$store.commit('handleBurger');"><b-icon icon="search"></b-icon></button></div>
  </section>
</template>

<script>
import CloseSearchSvg from "./common/svg/close-search-svg.vue";
import {debounce} from "../utils";
import infiniteScroll from 'vue-infinite-scroll'
export default {
  name: "search-aside-widget",
  components: {CloseSearchSvg},
  directives: {infiniteScroll},
  computed: {
    disableScroll() {
      return this.scroll_loader || this.pagination.page === this.pagination.last_page || this.loader || !this.search.length
    }
  },
  data() {
    return {
      search: '',
      applicants: [],
      scroll_loader: false,
      loader: false,
      pagination: {
        page: 1,
        per_page: 5,
        total: 0,
        last_page: 0
      },

    }
  },
  watch: {
    search: debounce(function(search){
      this.search = search.trim();
      if(this.search) this.fetchApplicants(1, true)
      else {
        this.applicants = []
        this.pagination.total = 0
      }
    }, 500),
  },
  mounted() {
    this.$bus.$on('searchAsideCloseEmmit', this.closeSearch)
  },
  methods: {
    closeSearch() {
      this.search = ''
    },
    loadMore() {
      if(!this.disableScroll) this.fetchApplicants(++this.pagination.page, false, true)
    },
    async fetchApplicants(page = 1, onSearch = true, onScroll = false) {
      console.log('fetchApplicants', page, onSearch, onScroll)
      if(onScroll) this.scroll_loader = true
      else if(onSearch) this.loader = true;
      const {per_page} = this.pagination;
      // params
      const params = {page, search: this.search, per_page, relations: ['vacancy.project', 'resume'], sort_by: 'id'}
      // request
      const {data: {data, meta}} = await this.$http.get('/api/applicants/get', {params})

      this.pagination.total = meta.total
      this.pagination.last_page = meta.last_page;

      if(onScroll) {
        this.scroll_loader = false
        this.applicants.push(...data)
      }
      else if(onSearch) {
        this.applicants = data;
        this.loader = false
      }
    }
  }
}
</script>

<style>
.main_aside .search_aside_widget_section {margin-bottom: 16px;}
.main_aside .search_aside_widget_section > div {height: 56px; background: var(--System-Header-bg, #161A1D); margin: -15px -15px 0 -15px; position: relative; padding: 4px 16px 16px;}
.main_aside .search_aside_widget_section > div > .input-group {position: relative;}
.main_aside .search_aside_widget_section > div > .input-group > .input-group-append {position:  absolute; z-index: 100; transform: translate(0, -50%); top: 50%; right: 6px;}
.main_aside .search_aside_widget_section > div > .input-group > .input-group-prepend {position:  absolute; z-index: 100; transform: translate(0, -50%); top: 50%; left: 6px;}
.main_aside .search_aside_widget_section > div > .input-group > .input-group-prepend > svg {fill: var(--System-Grey-4, #ADB5BD); width: 18px; height: 18px;}
.main_aside .search_aside_widget_section > div > .input-group >input {background: var(--Dark-Active-border, #2F2F32); color: var(--System-Permanent-text-white, #FFF);
  border-radius: 8px !important; border: none; padding-left: 32px; padding-right: 32px;}
.main_aside .search_aside_widget_section > div > .input-group >input:focus + .input-group-prepend > svg {fill: var(--System-Secondary-Active, #2591CB);}
.main_aside .search_aside_widget_section > div > .input-group >input:focus {box-shadow: none; border: 1px solid var(--System-Secondary-Active, #2591CB);}

.main_aside .search_aside_widget_section  .search_result_container {position: absolute; border: 1px solid var(--System-Secondary-Active, #2591CB); border-radius: 4px; box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
  background: var(--System-White, #FFF); top: 44px; z-index: 1001; width: 600px; padding: 10px 4px 10px 18px; height: 348px;}
.main_aside .search_aside_widget_section  .search_result_container > p {margin-bottom: 4px; color: var(--System-Text-grey, #868C95); font-size: 12px; font-weight: 500; line-height: 16px;}
.main_aside .search_aside_widget_section  .search_result_container > ul {margin: 0; list-style: none; display: flex; flex-direction: column; padding: 0; overflow-y: scroll;
  height: calc(100% - 18px);}

.main_aside .search_aside_widget_section  .search_result_container > ul > li {display: grid; grid-template-columns: 36px 1fr 1fr; grid-gap: 0 18px; padding: 8px 0;}
.main_aside .search_aside_widget_section  .search_result_container > ul > li > .photo_block {display: flex; align-items: center;}
.main_aside .search_aside_widget_section  .search_result_container > ul > li > .photo_block > img {width: 36px; height: 36px; border-radius: 4px !important;}
.main_aside .search_aside_widget_section  .search_result_container > ul > li > .title_block {margin-right: 32px; overflow: hidden;}
.main_aside .search_aside_widget_section  .search_result_container > ul > li > .title_block > * {text-overflow: ellipsis; overflow: hidden; white-space: nowrap}
.main_aside .search_aside_widget_section  .search_result_container > ul > li > .title_block > a {font-size: 14px; color: var(--System-Secondary-Active, #2591CB); line-height: 24px; font-weight: 500;}
.main_aside .search_aside_widget_section  .search_result_container > ul > li > .title_block > small {color: var(--System-Grey-2); font-size: 12px; font-weight: 500; line-height: 16px; display: block;}
.main_aside .search_aside_widget_section  .search_result_container > ul > li > .info_section {overflow: hidden;}
.main_aside .search_aside_widget_section  .search_result_container > ul > li > .info_section > * {text-overflow: ellipsis; overflow: hidden; white-space: nowrap}
.main_aside .search_aside_widget_section  .search_result_container > ul > li > .info_section > p {color: var(--System-Text, #253232); font-size: 14px; font-weight: 400; line-height: 24px; margin-bottom: 0;}
.main_aside .search_aside_widget_section  .search_result_container > ul > li > .info_section > small {color: var(--System-Grey-2); font-size: 12px; font-weight: 500;
  line-height: 16px; display: block;}


.main_aside .search_aside_widget_section  .search_result_container .spinner_block {padding: 20px; text-align: center; margin-left: -18px;}


.burger_not_expanded_white > .main_aside .search_aside_widget_section > div {display: flex; justify-content: center; align-items: center;}
.burger_not_expanded_white > .main_aside .search_aside_widget_section > div > button {padding: 8px 8px 4px 8px; background: white; border-radius: 8px; background: var(--Dark-Active-border);}
.burger_not_expanded_white > .main_aside .search_aside_widget_section > div > button > svg {fill: var(--System-Grey-4, #ADB5BD); width: 18px; height: 18px;}


</style>
